import { call, put } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import { setPrfoile, setPrfoileSuccess, setPrfoileError } from "../actions";
import { getProfilePassword, getProfilePasswordError, getProfilePasswordSuccess } from "../actions/profileActions";

export function* setProfileSaga({ payload }) {
  yield put(setPrfoile())
  try {
    const response = yield call(routes.setProfile, payload);
    yield put(setPrfoileSuccess(response));
  } catch (error) {    
    yield put(setPrfoileError(error.response.data));
  }
}

export function* setProfilePasswordSaga({ payload }) {
  yield put(getProfilePassword())
  try {
    const response = yield call(routes.setPassword, payload);
    
    yield put(getProfilePasswordSuccess(response));
  } catch (error) {
    yield put(getProfilePasswordError(error.response.data));
  }
}